/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1h_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long does it take to get into deep focus?`)
};

const es_timer_u1h_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto tarda uno en entrar en concentración profunda?`)
};

const de_timer_u1h_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange dauert es, in den Deep-Focus-Zustand zu kommen?`)
};

const nl_timer_u1h_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe lang duurt het om in diepe focus te komen?`)
};

const fr_timer_u1h_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de temps faut-il pour entrer dans un état de concentration profonde ?`)
};

const it_timer_u1h_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo ci vuole per entrare in uno stato di concentrazione profonda?`)
};

const pt_br2_timer_u1h_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo leva para entrar em foco profundo?`)
};

const pt_timer_u1h_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo demora a entrar em foco profundo?`)
};

const ja_timer_u1h_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深い集中状態に入るにはどのくらい時間がかかりますか？`)
};

const zh_timer_u1h_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进入深度专注状态需要多长时间？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1h_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1h_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1h_faq3_q", locale)
	if (locale === "en") return en_timer_u1h_faq3_q(inputs)
	if (locale === "es") return es_timer_u1h_faq3_q(inputs)
	if (locale === "de") return de_timer_u1h_faq3_q(inputs)
	if (locale === "nl") return nl_timer_u1h_faq3_q(inputs)
	if (locale === "fr") return fr_timer_u1h_faq3_q(inputs)
	if (locale === "it") return it_timer_u1h_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1h_faq3_q(inputs)
	if (locale === "pt") return pt_timer_u1h_faq3_q(inputs)
	if (locale === "ja") return ja_timer_u1h_faq3_q(inputs)
	return zh_timer_u1h_faq3_q(inputs)
};